'use strict'

module.exports = [

	{name: 'iframe-map', groups: ['Externé'],
		sections: ['top', 'bottom', 'full', 'large', 'small'],
	},

	{name: 'iframe-youtube', groups: ['Externé'],
		sections: ['top', 'bottom', 'full', 'large', 'small'],
	},

	{name: 'iframe-facebook', groups: ['Externé'],
		sections: ['top', 'bottom', 'full', 'large', 'small'],
	},
]



//////////////////
// WEBPACK FOOTER
// ./src/blocks/_multi-external.js
// module id = 150
// module chunks = 0